import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { userModalInterface } from 'src/app/util/interfaces/userModal';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class UserModalService {
	private getSearchUser = environment.baseApiUrl + 'cmdb/searchUser/{idEnduser}';

	constructor(
		private AuthLoginService: AuthLoginService,
		private ProfileService: ProfileService,
		private httpClient: HttpClient
	) {}

	getSearchUserId(idEnduser: string): Observable<userModalInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getSearchUserIdURL = this.getSearchUser.replace('{idEnduser}', idEnduser);

		return this.httpClient.get<JSON[]>(getSearchUserIdURL, { headers: headers }).pipe(
			map((enduser: any) => {
				if (!Array.isArray(enduser) || enduser.length === 0) {
					return [];
				}

				const newForm: userModalInterface = {
					fullName: enduser[0].fullName,
					location: enduser[0].location,
					site: enduser[0].site,
					phone: enduser[0].phone,
					email: enduser[0].email,
					login: enduser[0].login,
					uniquekey: enduser[0].uniquekey,
					description: enduser[0].description,
					locale: enduser[0].locale,
					mobile: enduser[0].mobile,
					department: enduser[0].department,
					supervisor: enduser[0].supervisor,
				};
				return [newForm];
			})
		);
	}
}
